import { createSlice } from "@reduxjs/toolkit";
import { getNotificationList } from "../Actions/auth";


const initialState = {
    loading: false,
    notificationList: [],
}

const NotificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotificationList.fulfilled, (state, { payload }) => {
            if (payload?.statusCode == 200) {
                state.success = true;
                state.notificationList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
    },
});

export default NotificationSlice.reducer;